import Subtext from "@/components/pieces/form/Subtext";

export default function SmallCaps(props) {
  return (
    <Subtext {...props} style={{ textTransform: "uppercase", ...props.style }}>
      {props.children}
    </Subtext>
  );
}
